<script setup>
import { computed, ref, watch} from 'vue';
import ILink from '@components/ILink/ILink.vue';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import IFastBuyModal from '@components/IFastBuyModal/IFastBuyModal.vue';
import EventItemsSkeleton from '@components/EventItemsSkeleton.vue';
import CartItem from './components/CartItem.vue';
import { useCartDataProvider } from '../../hooks/useCartDataProvider.js';
import useCartStore from '../../store/modules/cart.js';
import Announcement from '../../components/Announcement.vue';
import BulkBuyTeacherInfoLabel from '../cart/components/BulkBuyTeacherInfoLabel.vue';

const cartStore = useCartStore();
const { isGuest } = useCartDataProvider();

const orders = computed(() => cartStore.getCart.value);
const loadingCart = ref(true);
cartStore.loadCart().finally(() => (loadingCart.value = false));

const isBulkBuyTeacherInfoEnable = computed(() => cartStore.getCart.value.some(order => !!order.bulkBuyTeacherParams)); 
const isBulkBuyTeacherInfoShow = ref(true);

</script>

<template>
  <div class="lk">
    <div class="lk__top">
      <Announcement>
      <template #announcement__info_btn_text>
        {{ translator.t("main", "Cart") }}
      </template>
        <template #announcement__info_text>
          <ILink
            v-if="orders.length"
            :icon-name="'close'"
            class="button close-btn lk__close-btn announcement__info_clear"
            @click="cartStore.clearCart"
          >
            <span>{{ translator.t("main", "Clear") }}</span>
          </ILink>
        </template>
      </Announcement>
    </div>
    <BulkBuyTeacherInfoLabel 
      v-if="isBulkBuyTeacherInfoEnable"
      v-show="isBulkBuyTeacherInfoShow"
      @remove-bulk-info-label="isBulkBuyTeacherInfoShow = false"
    />
    <EventItemsSkeleton v-model="loadingCart">
      <div v-if="orders.length" class="order">
        <CartItem v-for="order in orders" :key="order.id" :order="order" />
      </div>

      <div v-if="!orders.length" class="lk__empty">
        <div class="lk__small-title">{{ translator.t("main", "The cart is empty") }}</div>
        <p>{{ translator.t("main", "Your cart is empty. Let\'s buy a ticket to the match!") }}</p>
        <a href="/" class="lk__button btn reset-btn">{{ translator.t("main", "Back to the playbill") }}</a>
      </div>
    </EventItemsSkeleton>
  </div>
  <IFastBuyModal v-if="isGuest" v-model="cartStore.isShowFastBuyModal.value" />
</template>
